import '@fancyapps/fancybox';

(function ($) {
  'use strict';

  $(document).ready(function () {
    // Video popup using fancybox
    $('.section-video .play-icon').on('click', function () {
      const videoType = $(this).data('video-type');
      const videoUrl = $(this).data('video-url');

      const type = videoType === 'upload' ? 'video' : 'iframe';

      $.fancybox.open({
        src: videoUrl,
        type: type,
        iframe: {
          preload: false,
        },
      });
    });
  });
})(jQuery);
